
export function createIdsFromSever({idArray}){
    console.log('idArray',idArray)
    // return {
    //     ids:idArray.map(item => {            
    //         // return `<Style styleID="${styleID.includes('新增') ? 0 : styleID}"  supplyno="${supplyno}" size="${size}" price="${price}" remain="${remain}" ></Style>`//1:0.1;2:0.2
    //         return item[1]
    //     }).join(',')
    // }
    return {
        ids:idArray.join(',')
    }
}

export function createMoniTypeIdsFromSever({idArray2}){
    console.log('idArray2',idArray2)
    // return {
    //     ids:idArray.map(item => {            
    //         // return `<Style styleID="${styleID.includes('新增') ? 0 : styleID}"  supplyno="${supplyno}" size="${size}" price="${price}" remain="${remain}" ></Style>`//1:0.1;2:0.2
    //         return item[1]
    //     }).join(',')
    // }
    return {
        ids:idArray2.join(',')
    }
}


//原来二级结构
// export function changeStrtoArray({userIds}){
//     var userArray=[];
//     var ids = userIds.split(',');
//     ids.forEach(element => {
//         if (element){
//             var subArr=[];
//             subArr.push(element.split('-')[0]);
//             subArr.push(element.split('-')[1]);
//             userArray.push(subArr)
//         }
//     });
//     return {userArray: userArray};
//     // return userArray;
// }


export function changeStrtoArray({userIds}){
    // var userArray=[];
    var subArr=[];
    var ids = userIds.split(',');
    ids.forEach(element => {
        if (element){
   
            subArr.push(parseInt(element));

        }
    });
    return {userArray: subArr};
    // return userArray;
}